/* eslint react/forbid-prop-types: 0 */
/* global translations, globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

class PaymentsProgressBar extends Component {
  state = {
    fixed: false,
  };

  handleScroll = this.handleScroll.bind(this);

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.setState({
      fixed: (window.scrollY > document.getElementById('header').offsetHeight),
    });
  }

  openInNewTab(url) {
    window.open(url, "_blank", "noreferrer");
  };

  render() {
    const { verificationStatus } = this.props;
    //
    const steps = {
      regular: [
        `${get(translations, 'txt: izvēlies dienu skaitu', 'Izvēlies dienu skaitu')}`,
        `${get(translations, 'txt: Izvēlies maksāšanas veidu', 'Izvēlies maksāšanas veidu')}`,
        `${get(translations, 'txt: norēķinies', 'Norēķinies')}`,
      ],
      sms: [
        `${get(translations, 'txt: izvēlies dienu skaitu', 'Izvēlies dienu skaitu')}`,
        `${get(translations, 'txt: ievadi tālruņa numuru', 'Ievadi tālruņa numuru')}`,
        `${get(translations, 'txt: ievadi PIN kodu', 'Ievadi PIN kodu')}`,
      ],
    };

    if(get(globals, 'hasVerification', false) && verificationStatus !== "verified") {
      steps.regular.push(`${get(translations, 'txt: verificējies', 'Verificējies')}`);
    }

    //
    const { fixed } = this.state;

    //
    const {
      type,
      active,
      sms,
    } = this.props;

    // For 'highlighted' remove first step and set sms steps the same as regular.
    if (type === 'highlight') {
      steps.regular.shift();
      steps.sms = steps.regular;
    }

    // Gift subscription
    if (type === 'subscription_other') {
      steps.regular[0] = `${get(translations, 'txt: izvēlies dāvanas vērtību', 'Izvēlies dāvanas vērtību')}`;
      steps.sms[0] = `${get(translations, 'txt: izvēlies dāvanas vērtību', 'Izvēlies dāvanas vērtību')}`;
    }

    // Main container class for both regular and sms
    const mainClasses = ['paymentSteps', 'mbxl'];
    //
    if (type === 'highlight') {
      mainClasses.push('paymentSteps--showTwo');
    }
    //
    if (fixed) {
      mainClasses.push('paymentSteps--fixed');
    }

    if(!sms && steps.regular[3]) {
      mainClasses.push('paymentSteps--showFour');
    }

    //
    return (
      <div className={`paymentSteps-container ${type === 'highlight' ? 'mbm' : 'mbxl'}`}>
        <ul className={`${mainClasses.join(' ')}${sms ? ' is-hidden' : ''}`}>
          <li className="paymentSteps-one is-active">
            <a href="/">
              {`1. ${steps.regular[0]}`}
            </a>
          </li>
          <li className={`paymentSteps-two${active && type !== 'highlight' ? ' is-active' : ''}`}>
            <a href="/">
              {`2. ${steps.regular[1]}`}
            </a>
          </li>
          {steps.regular[2] && (
            <li className="paymentSteps-three">
              <a href="/">
                {`3. ${steps.regular[2]}`}
              </a>
            </li>
          )}
          {steps.regular[3] && (
            <li className="paymentSteps-four" onClick={() => this.openInNewTab("/verification")}>
              <a href="/">
                {`4. ${steps.regular[3]}`}
              </a>
            </li>
          )}
        </ul>
        <ul className={`${mainClasses.join(' ')}${!sms ? ' is-hidden' : ''} paymentSteps--sms`}>
          <li className="paymentSteps-one is-active">
            <a href="/">
              {`1. ${steps.sms[0]}`}
            </a>
          </li>
          <li className={`paymentSteps-two${active ? ' is-active' : ''}`}>
            <a href="/">
              {`2. ${steps.sms[1]}`}
            </a>
          </li>
          {steps.sms[2] && (
            <li className="paymentSteps-three">
              <a href="/">
                {`3. ${steps.sms[2]}`}
              </a>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

PaymentsProgressBar.propTypes = {
  type: PropTypes.string.isRequired,
  active: PropTypes.string,
  sms: PropTypes.bool,
};
PaymentsProgressBar.defaultProps = {
  active: null,
  sms: false,
};

export default PaymentsProgressBar;
